import gql from "graphql-tag";

export const MY_HR_EMPLOYEE_SUBSCRIPTION = gql`
  subscription employeesSubscription {
    employeesSubscription
  }
`;
